import { render } from "./NotificationCorrectOption.vue?vue&type=template&id=99d4a3c4&ts=true"
import script from "./NotificationCorrectOption.vue?vue&type=script&lang=ts"
export * from "./NotificationCorrectOption.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__